import React, { useEffect, useState } from "react";
import { Grid, Skeleton } from "@mui/material";
import { Box } from "@mui/system";
import Chart from "react-apexcharts";
import { getVisitTypeAM, getVisitByLocationAM, getDealerVisitAM, getPJPdataAM, getDealerVisitPerDayAM, getTimeSpentDealerAM } from "_controllers/officer";
import { useSelector } from "react-redux";
import { PageHeader, SectionCard, useChartBase, mergeChartOptions } from "_shared/ui";

// Fixed-height wrapper so every chart / skeleton slot lines up on the grid.
const ChartSlot = ({ children }) => (
  <Box sx={{ height: 340, display: "flex", flexDirection: "column", justifyContent: "center" }}>
    {children}
  </Box>
);

const AreaManagerDashboard = () => {
  const { user } = useSelector((state) => state.user);
  const base = useChartBase();

  const [planned, setPlanned] = useState(0)
  const [unplanned, setUnplanned] = useState(0)
  const [totalVisits, setTotalVisits] = useState(0)

  const [lessThan100, setLessThan100] = useState(0)
  const [moreThan100, setMoreThan100] = useState(0)
  const [notCompleted, setNotCompleted] = useState(0)

  const [activeDealerVisits, setActiveDealerVisits] = useState(0)
  const [inactiveDealerVisits, setInactiveDealerVisits] = useState(0)
  const [activeDealers, setActiveDealers] = useState(0)

  const [uniqueVisits, setUniqueVisits] = useState(0)
  const [uniquetotalVisits, setUniqueTotalVisits] = useState(0)

  const [pjpData, setPjpData] = useState([])
  const [perDayVisitData, setPerDayVisitData] = useState([])
  const [dealerTimeSpent, setDealerTimeSpent] = useState([])

  const [loader1, setLoader1] = useState(true)
  const [loader2, setLoader2] = useState(true)
  const [loader3, setLoader3] = useState(true)
  const [loader4, setLoader4] = useState(true)
  const [loader5, setLoader5] = useState(true)
  const [loader6, setLoader6] = useState(true)

  const [hi, setHi] = useState({
    name: "shubhan",
    val: true
  })
  useEffect(() => {
    setHi({ ...hi, name: "sharma" })
  }, [])

  useEffect(() => {
    setHi({ ...hi, val: false })
  }, [])

  // console.log("hi", hi);

  useEffect(async () => {
    await getVisitTypeAM({
      // zone: user.regionCode,
      // startDate,
      // endDate,
    }).then((data) => {
      setPlanned(data?.plannedVisits)
      setUnplanned(data?.unplannedVisits)
      setTotalVisits(data?.totalVisits)
      setLoader1(false)
    }).catch((err) => console.log("err", err))
  }, []);

  useEffect(async () => {
    await getVisitByLocationAM({
      // zone: user.regionCode,
      // startDate,
      // endDate,
    }).then((data) => {
      setLessThan100(data?.lessThan100)
      setMoreThan100(data?.moreThan100)
      setNotCompleted(data?.pendingVisits)
      setLoader2(false)
    }).catch((err) => console.log("err", err))

  }, []);

  useEffect(async () => {
    await getDealerVisitAM({
      // zone: user.regionCode,
      // startDate,
      // endDate,
    }).then((data) => {
      setUniqueVisits(data?.uniqueDealerVisits?.uniqueVisits)
      setUniqueTotalVisits(data?.uniqueDealerVisits?.totalVisits)
      setActiveDealers(data?.activeDealers)
      setActiveDealerVisits(data?.visitByDealerStatus.reduce((acc, obj) => {
        if (obj._id === "A") {
          acc += obj.count;
        }
        return acc;
      }, 0))
      setInactiveDealerVisits(data?.visitByDealerStatus.reduce((acc, obj) => {
        if (obj._id === "I") {
          acc += obj.count;
        }
        return acc;
      }, 0))
      // setLoading(false)
      setLoader3(false)
    }).catch((err) => console.log("err", err))
  }, []);

  useEffect(async () => {
    await getPJPdataAM({
      // startDate,
      // endDate,
    }).then((data) => {
      console.log("pjp", data);
      setPjpData(data?.data)
      setLoader4(false)
    }).catch((err) => console.log("err", err))
  }, []);

  useEffect(async () => {
    await getDealerVisitPerDayAM({
      // startDate,
      // endDate,
    }).then((data) => {
      console.log("dealer per day", data);
      setPerDayVisitData(data?.data)
      setLoader5(false)
    }).catch((err) => console.log("err", err))
  }, []);

  useEffect(async () => {
    await getTimeSpentDealerAM({
      // startDate,
      // endDate,
    }).then((data) => {
      console.log("time", data);
      setDealerTimeSpent(data?.data)
      setLoader6(false)
    }).catch((err) => console.log("err", err))
  }, []);

  return (
    <>
      <PageHeader title="Area Manager Dashboard" subtitle="Field visit analytics overview" />
      <Grid container spacing={2.5}>
        <Grid item xs={12} md={6}>
          <SectionCard title="Visit Type">
            <ChartSlot>
              {loader1 ? (
                <Skeleton variant="rectangular" width="100%" height="100%" />
              ) : (
                <Chart
                  type="donut"
                  width={"100%"}
                  height={"100%"}
                  series={[planned, unplanned]}
                  options={mergeChartOptions(base, {
                    labels: ["Planned", "Unplanned"],
                    plotOptions: {
                      pie: {
                        startAngle: -90,
                        endAngle: 90,
                      },
                    },
                    legend: {
                      position: "top",
                    },
                  })}
                ></Chart>
              )}
            </ChartSlot>
          </SectionCard>
        </Grid>

        <Grid item xs={12} md={6}>
          <SectionCard title="Visit By Dealer Status">
            <ChartSlot>
              {loader3 ? (
                <Skeleton variant="rectangular" width="100%" height="100%" />
              ) : (
                <Chart
                  type="donut"
                  width={"100%"}
                  height={"100%"}
                  series={[activeDealerVisits, inactiveDealerVisits]}
                  options={mergeChartOptions(base, {
                    labels: ["Active", "In-Active"],
                    plotOptions: {
                      pie: {
                        startAngle: -90,
                        endAngle: 90,
                      },
                    },
                    legend: {
                      position: "top",
                    },
                  })}
                />
              )}
            </ChartSlot>
          </SectionCard>
        </Grid>

        <Grid item xs={12} md={6}>
          <SectionCard title="Unique Dealer Visits">
            <ChartSlot>
              {loader3 ? (
                <Skeleton variant="rectangular" width="100%" height="100%" />
              ) : (
                <Chart
                  type="donut"
                  width={"100%"}
                  height={"100%"}
                  series={[
                    uniqueVisits,
                    uniquetotalVisits - uniqueVisits,
                  ]}
                  options={mergeChartOptions(base, {
                    labels: ["Unique Dealers Visits", "Repeated Dealers"],
                    plotOptions: {
                      pie: {
                        startAngle: -90,
                        endAngle: 90,
                        donut: {
                          labels: {
                            show: true,
                            name: {
                              formatter: function (val) {
                                return "Total Visits";
                              },
                            },
                            total: {
                              show: true,
                              formatter: function (val) {
                                return uniquetotalVisits ?? 100;
                              },
                            },
                          },
                        },
                      },
                    },
                    legend: {
                      position: "top",
                    },
                  })}
                />
              )}
            </ChartSlot>
          </SectionCard>
        </Grid>

        <Grid item xs={12} md={6}>
          <SectionCard title="Total Visits / Active Dealer Base">
            <ChartSlot>
              {loader3 ? (
                <Skeleton variant="rectangular" width="100%" height="100%" />
              ) : (
                // change static value of 1000
                <Chart
                  type="donut"
                  width={"100%"}
                  height={"100%"}
                  series={[10000, activeDealers]}
                  options={mergeChartOptions(base, {
                    labels: ["Unique Dealers", "Active Dealers"],
                    plotOptions: {
                      pie: {
                        startAngle: -90,
                        endAngle: 90,
                      },
                    },
                    legend: {
                      position: "top",
                    },
                  })}
                />
              )}
            </ChartSlot>
          </SectionCard>
        </Grid>

        <Grid item xs={12} md={6}>
          <SectionCard title="Visit By Start & End Location">
            <ChartSlot>
              {loader2 ? (
                <Skeleton variant="rectangular" width="100%" height="100%" />
              ) : (
                <Chart
                  type="donut"
                  width={"100%"}
                  height={"100%"}
                  series={[
                    lessThan100,
                    moreThan100,
                    notCompleted,
                  ]}
                  options={mergeChartOptions(base, {
                    labels: ["Not-Ended", ">100m", "<100m"],
                    legend: {
                      position: "top",
                    },
                  })}
                />
              )}
            </ChartSlot>
          </SectionCard>
        </Grid>

        <Grid item xs={12} md={6}>
          <SectionCard title="PJP Planning Status">
            <ChartSlot>
              {loader4 ? (
                <Skeleton variant="rectangular" width="100%" height="100%" />
              ) : (
                <Chart
                  type="bar"
                  width={"100%"}
                  height={"100%"}
                  series={[
                    {
                      name: "Count",
                      data: pjpData.map((p) => { return p?.count }),
                    },
                  ]}
                  options={mergeChartOptions(base, {
                    labels: pjpData.map((p) => { return p?.user }),
                    plotOptions: {
                      bar: {
                        dataLabels: {
                          position: 'top', // top, center, bottom
                        },
                      }
                    },
                    dataLabels: {
                      enabled: true,
                      offsetY: -20,
                      style: {
                        fontSize: '12px',
                      }
                    },
                    tooltip: { followCursor: true },
                    legend: {
                      position: "top",
                    },
                  })}
                />
              )}
            </ChartSlot>
          </SectionCard>
        </Grid>

        <Grid item xs={12} md={6}>
          <SectionCard title="Average Dealer Visits / Day">
            <ChartSlot>
              {loader5 ? (
                <Skeleton variant="rectangular" width="100%" height="100%" />
              ) : (
                <Chart
                  type="bar"
                  width={"100%"}
                  height={"100%"}
                  series={[
                    {
                      name: "Last Month",
                      data: perDayVisitData.map((p) => { return p?.value?.previousMonth }),
                    },
                    {
                      name: "Current Month",
                      data: perDayVisitData.map((p) => { return p?.value?.currentMonth }),
                    },
                  ]}
                  options={mergeChartOptions(base, {
                    labels: perDayVisitData.map((p) => { return p?.territory }),
                    legend: {
                      position: "top",
                    },
                    plotOptions: {
                      bar: {
                        columnWidth: '60%',
                        dataLabels: {
                          position: 'top', // top, center, bottom
                        },
                      }
                    },
                    dataLabels: {
                      enabled: true,
                      offsetY: -20,
                      // hide "0" labels so zero-height bars don't leave floating labels over the neighbouring bar
                      formatter: (val) => (val ? val : ''),
                      style: {
                        fontSize: '12px',
                      }
                    },
                    stroke: {
                      show: true,
                      width: 3,
                    },
                    tooltip: { followCursor: true },
                  })}
                />
              )}
            </ChartSlot>
          </SectionCard>
        </Grid>

        <Grid item xs={12} md={6}>
          <SectionCard title="Average Time Spent / Dealer (mins)">
            <ChartSlot>
              {loader6 ? (
                <Skeleton variant="rectangular" width="100%" height="100%" />
              ) : (
                <Chart
                  type="bar"
                  width={'100%'}
                  height={'100%'}
                  series={[
                    {
                      name: "Last Month",
                      data: dealerTimeSpent.map((p) => { return p?.value === "NA" ? 0 : p?.value }),
                    },
                  ]}
                  options={mergeChartOptions(base, {
                    labels: dealerTimeSpent.map((p) => { return p?.territory }),
                    tooltip: { followCursor: true },
                  })}
                />
              )}
            </ChartSlot>
          </SectionCard>
        </Grid>
      </Grid>
    </>
  )
}

export default AreaManagerDashboard
